const validateAnswer = function (errors, vm, showTip) {
  const { optionList, value, answerConfig: { requireInd, otherRequireInd, answerLimitInd } } = this
  let { answerConfig: { minAnswerNum, maxAnswerNum } } = this
  minAnswerNum *= 1
  maxAnswerNum *= 1
  const len = value.length
  if (requireInd === '1') {
    if ((answerLimitInd !== '1' && !len) || (minAnswerNum > 0 && !len)) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }
  if (!len) {
    return !errors.length
  }

  // 其他请注明选项
  const otherOptionList = optionList.filter(item => value.includes(item.id) && item.type === 'other')
  if (otherOptionList && otherOptionList.length > 0) {
    otherOptionList.forEach(otherItem => {
      if (otherItem && otherRequireInd === '1' && !otherItem.otherValue) {
        errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      }
    })
    if (errors.length > 0) {
      return !errors.length
    }
  }

  if (answerLimitInd === '1') {
    if (minAnswerNum !== 0 && len < minAnswerNum) {
      let minAnswerNumPhrase = vm.cvtLang('minAnswerNum', vm.surveyInfoLang.minAnswerNum) || ''
      errors.push(minAnswerNumPhrase.replace('${n}', minAnswerNum))
    } else if (maxAnswerNum !== 0 && len > maxAnswerNum) {
      let maxAnswerNumPhrase = vm.cvtLang('maxAnswerNum', vm.surveyInfoLang.maxAnswerNum) || ''
      errors.push(maxAnswerNumPhrase.replace('${n}', maxAnswerNum))
    }
  }
  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/CheckBox/answerValidate.js